import { formatDollars } from '@kwenta/sdk/utils'
import { type FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import CalculatorIcon from 'assets/svg/futures/calculator-icon.svg'
import DepositWithdrawArrowsIcon from 'assets/svg/futures/deposit-withdraw-arrows.svg'
import { Body } from 'components/Text'
import { FlexDivRow } from 'components/layout/flex'
import { DrawerTab, WithdrawTab } from 'sections/accounts/constants'
import { setOpenModalWithParams } from 'state/app/reducer'
import { onboardCrossMargin } from 'state/futures/actions'
import { setProfitCalculatorVisible } from 'state/futures/reducer'
import { selectCrossMarginMarginInfo, selectSnxV3Account } from 'state/futures/snxPerpsV3/selectors'
import { useAppDispatch, useAppSelector } from 'state/hooks'

const TradePanelAvailableMargin: FC = () => {
	const { t } = useTranslation()
	const { availableMargin } = useAppSelector(selectCrossMarginMarginInfo)
	const crossMarginAccount = useAppSelector(selectSnxV3Account)
	const dispatch = useAppDispatch()

	const handleShowProfitCalculator = useCallback(() => {
		dispatch(setProfitCalculatorVisible(true))
	}, [dispatch])

	return (
		<Container>
			<AvailableMarginContainer>
				<Body color="secondary">{t('futures.market.trade.trade-balance.available')}:</Body>
				<StyledRow
					onClick={() =>
						dispatch(
							crossMarginAccount
								? setOpenModalWithParams({
										type: 'manage_wallet',
										params: { tab: DrawerTab.WITHDRAW, innerTab: WithdrawTab.INTERNAL },
									})
								: onboardCrossMargin()
						)
					}
				>
					<Body color="primary">{formatDollars(availableMargin)}</Body>
					{!!crossMarginAccount && <ManageAccountIcon />}
				</StyledRow>
			</AvailableMarginContainer>
			<CalculatorContainer onClick={handleShowProfitCalculator}>
				<Body color="secondary">{t('futures.market.trade.trade-balance.calculator')}</Body>
				<StyledCalculatorIcon />
			</CalculatorContainer>
		</Container>
	)
}

const Container = styled(FlexDivRow)`
	margin-bottom: 8px;
`

const CalculatorContainer = styled.div`
	display: flex;
	gap: 7px;
	cursor: pointer;
`

const AvailableMarginContainer = styled.div`
	display: flex;
	gap: 7px;
`

const StyledRow = styled(FlexDivRow)`
	cursor: pointer;
	gap: 7px;
`

const ManageAccountIcon = styled(DepositWithdrawArrowsIcon)`
	cursor: pointer;
	path {
		fill: ${(props) => props.theme.colors.selectedTheme.newTheme.text.preview};
	}
`

const StyledCalculatorIcon = styled(CalculatorIcon)`
	path {
		fill: ${(props) => props.theme.colors.selectedTheme.newTheme.text.preview};
	}
`

export default TradePanelAvailableMargin
